<template>
  <div>
    <div>
      <div class="row">
        <div class="col-12 bg-dark-blue">
          <img src="/img/arrow-left-white.svg" class="mt-4" height="30" @click="$router.back()" />
          <h5 class="text-align-right white bold mt-3 mb-5">Muito bem, vamos para a proxima sessão de perguntas</h5>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12 col-sm-12 center-container">
          <h1 class="title dark-blue-normal bold">Avaliação da atividade física e mobilidade</h1>
        </div>
        <div class="bottom">
          <button class="continue-btn" @click.prevent="handle">
            <span>INICIAR </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
    };
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    async handle() {
      this.$router.push("/problema-coracao");
    },
  },
};
</script>
<style scoped>

</style>
